export const SUCCESS_TRANSFER_USER_SUBSCRIPTION = 'SUCCESS_TRANSFER_USER_SUBSCRIPTION';

export const successTransferUserSubscriptions = () => ({
  type: SUCCESS_TRANSFER_USER_SUBSCRIPTION
});
